var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"transparent","transition-property":"opacity","transition-duration":"400ms"}},[_c('div',{staticClass:"toast-box"},[_vm._v("\n        "+_vm._s(_vm.toastText)+"\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }